export default "__VITE_ASSET__CacszPY9__"